/**
 * Конспект разговора (`voicelab/konspekt`) — блок «Уже обсуждали…» ровно так, как его получит модель на
 * следующей реплике, и версия словаря тем. Спека `docs/specs/2026-11-05-dialog-konspekt-design.md` §7.
 */
import type { LabKonspekt } from "@/lib/voiceLab";

export function KonspektBox({
  konspekt,
  className = "",
  showEmpty = false,
}: {
  konspekt: LabKonspekt | null | undefined;
  className?: string;
  showEmpty?: boolean;
}) {
  if (!konspekt) return null;
  const пусто = !konspekt.text.trim();
  if (пусто && !showEmpty) return null;
  return (
    <section
      className={`flex flex-col gap-1 rounded-[var(--radius-ui)] border border-border bg-bg-subtle px-2.5 py-2 text-[12.5px] ${className}`}
      data-annot="конспект разговора"
    >
      <div className="flex flex-wrap items-baseline gap-x-2">
        <span className="font-medium">Конспект для модели</span>
        <span className="text-fg-muted">· {konspekt.version}</span>
      </div>
      {пусто ? (
        <span className="text-fg-muted">конспект пуст</span>
      ) : (
        <pre className="whitespace-pre-wrap break-words font-sans leading-relaxed">{konspekt.text}</pre>
      )}
    </section>
  );
}
